import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
const globalHost = "divalovers.com";

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
      
    {
      path: "/news/:pagenum",
      components: {
        //default: () => import('./views/Page.vue'),
        default: () => import('./views/News.vue')
      },
      name: "news"
    },
    {
      // Redirect To Have Proper Router Navigation
      // The "1" loads the correct News/View
      path: '/news',
      redirect: {
        path: "/news/1",
      }
    },
    {
      path: '/news/',
      redirect: {
        path: "/news/1",
      }
    },
    {
      path: '/news/1/',
      redirect: {
        path: "/news/1",
      }
    },
    {
      path: '/jd-news/:myslug',
      components: {
        default: () => import('./views/SingleNews.vue')
      },
      name: "singlepost"
    },
    {
      path: '/blank/*',
      beforeEnter: (to, from, next)=> {
        window.open(to.params.pathMatch);
        next(false);
      }
    },
    {
      path: '/external/*',
      beforeEnter: (to, from, next) => {
        location.href = to.params.pathMatch;
        next(false);
      }
    },
    {
      path: '/fanclub',
      beforeEnter() {
        location.href = 'https://'+globalHost+'/fanclub/'
      }
    },
    {
      path: '/epk',
      beforeEnter() {
        location.href = 'https://' + globalHost + '/epk/'
      }
    },
    {
      path: '/downloads',
      beforeEnter() {
        console.log("Go To Downloads");
        location.href = 'https://' + globalHost + '/downloads/'
      }
    },
    {
      path: "*",
      components: {
        default: () => import('./views/Page.vue')
      },
    },

  ]
});
